const tpl = (fields) => ({ page: 'schedules', ...fields })

export const SCHEDULE_TEMPLATES_PART02 = [
  tpl({
    id: 'demo-tpl-sch-funding',
    title: 'Prospect funding alerts',
    category: 'Research',
    cron: '0 7 * * *',
    apps: ['Web research', 'HubSpot'],
    description: 'A daily check for funding rounds, acquisitions, and leadership changes at accounts in your pipeline.',
    steps: [
      'Read the companies attached to open HubSpot deals',
      'Search news from the last 24 hours for each one',
      'Send a short list with links and what each change means for the deal',
    ],
    prompt:
      'Every day at 7:00, check the news for funding rounds, acquisitions, and leadership changes at companies with open deals in HubSpot, and send me a short list with links and what it means for each deal.',
  }),
  tpl({
    id: 'demo-tpl-sch-stale-prs',
    title: 'Stale pull request nudge',
    category: 'Engineering',
    cron: '0 14 * * 1-5',
    apps: ['GitHub', 'Slack'],
    description: 'An afternoon nudge for pull requests nobody has reviewed in two days.',
    steps: ['Find open PRs with no review activity for 48 hours', 'Note the author and requested reviewers', 'Post the list to #eng'],
    prompt:
      'Every weekday at 14:00, find open pull requests in our GitHub repositories with no review activity for 48 hours and post a list to Slack #eng with the author and requested reviewers.',
  }),
  tpl({
    id: 'demo-tpl-sch-trademark',
    title: 'Trademark journal watch',
    category: 'Legal',
    cron: '0 10 * * 1',
    apps: ['Web research'],
    description: 'Every Monday, scans the new IP-India trademark journal for marks that clash with yours.',
    steps: [
      'Download the latest journal from the IP-India site',
      'Compare newly advertised marks with your brand names',
      'List close matches with application number, class, and opposition deadline',
    ],
    prompt:
      'Every Monday at 10:00, download the latest IP-India trademark journal and flag newly advertised marks that are similar to our brand names, with application number, class, and the opposition deadline.',
  }),
]
